module.exports = __webpack_public_path__ + "static/media/catering.aa3257ab.jpeg";